import { useState, useCallback } from 'react';
import { extractErrorMessage } from '../utils/errorUtils';
import { validateAuthForm } from '../utils/validation';

export const useAuthForm = (initialState, validationType = null) => {
  const [formData, setFormData] = useState(initialState);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const onChange = useCallback((e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (error) setError('');
    if (success) setSuccess('');
  }, [error, success]);

  const handleSubmit = useCallback((e, serviceFunction, onSuccess) => {
    e.preventDefault();
    if (submitting) return;

    setError('');
    setSuccess('');
    
    if (validationType) {
      const validationError = validateAuthForm(formData, validationType);
      if (validationError) {
        setError(validationError);
        return;
      }
    }

    setSubmitting(true);

    return Promise.resolve(serviceFunction(formData))
      .then(response => {
        const successMsg = onSuccess ? onSuccess(response) : '';
        if (successMsg) setSuccess(successMsg);
      })
      .catch(err => {
        const message = extractErrorMessage(err);
        setError(message);
      })
      .finally(() => {
        setSubmitting(false);
      });
  }, [formData, submitting, validationType]);

  return {
    formData,
    setFormData,
    submitting,
    error,
    setError,
    success,
    setSuccess,
    showPassword,
    setShowPassword,
    showConfirm,
    setShowConfirm,
    onChange,
    handleSubmit
  };
};